import React, { useEffect, useState } from "react";
import { Breadcrumb, Layout, Menu, theme } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { callApi } from "../api/apiCaller";
import { GreenNotify, RedNotify } from "../helper/helper";
import Trainer from "../pages/trainerList/trainderList";

import Privacy from "../pages/privacyPolicies/privacyPolicies";
import routes from "../api/routes";
import {
  homeIcon,
  redTrash,
  CategoryIcon,
  SUbCatIcon,
  blogIcon,
  userIcon,
  privacyIcon,
  videoIcon,
  yogIcon,
  serviceIcon,
  feedbackIcon,
  trainerIcon,
} from "../assets";
import "./layout.css";
import Header2 from "../components/header/header";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import Blog from "../pages/yogaBlogs/yogaBlogs";
import UserLists from "../pages/userList/userList";
import Videos from "../pages/yogaVideose/yogaVideos";
import Loader from "../components/loader/loader";
import Contact from "../pages/ContactUs/contactUs";
import LandingPage from "../pages/landingPage/landingPage";
import FaceYoga from "../pages/faceYogas/faceYogas";
import TermsOfUse from "../pages/termsOfUse/termsOfUse";
import Categories from "../pages/Categories/categories";
import SubCategories from "../pages/subCategories/subCategories";
import UserSupport from "../pages/userSupport/userSupportList";
import Feedbacks from "../pages/feedbacks/feedbacks";
const { Header, Content, Footer, Sider } = Layout;

const LayoutDashboard = () => {
  const [isloading, setIsLoading] = useState(false);
  const [isOrganizerModalVisible, setIsOrganizerModalVisible] = useState(false);
  const [isPrivacyModalVisible, setIsPrivacyModalVisible] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  let body = {
    device: {
      id: "3242fwefwe4324",
      deviceToken: "ewtfefwfwerer435dsfhjdsfghjesf",
    },
  };
  const logOut = () => {
    callApi(
      "POST",
      `${routes.logOut}`,
      body,
      setIsLoading,
      (res) => {
        console.log("Logout response", res);

        if (res.status === 200) {
          GreenNotify("Logout Successful");
          localStorage.clear();
          navigate("/login", { replace: true });
        } else {
          localStorage.clear();
          navigate("/login", { replace: true });
        }
      },
      (error) => {
        RedNotify("Error occurred while logging out");
        localStorage.clear();
      }
    );
  };

  useEffect(() => {
    return () => setIsLoading(false);
  }, []);

  const currentPath = location.pathname;
  const routeToKey = {
    "/users-list": "1",
    "/yogas": "2",
    "/categories": "3",
    "/sub_categories": "18",
    "/deliveries": "4",
    "/videos": "5",
    "/blogs": "6",
    "/userSupports": "7",
    "/termsOfUse": "12",
    "/feedbacks": "9",
    "/privacy": "10",
    "/about-us": "13",
    "/contact-us": "14",
    "/trainer": "40",
  };

  const currentKey = routeToKey[currentPath];

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Loader loading={isloading} />
      <Sider style={{ background: "#0B1B2D" }} width={280}>
        <div
          style={{
            padding: "2rem 0",
            textAlign: "center",
            color: "white",
            fontSize: "3rem",
            scrollBehavior: "smooth",
            position: "sticky",
            borderBottom: "10px",
            height: "250px",
          }}
        >
          <h5>FACEYOGA</h5>
        </div>
        <Menu
          style={{ marginTop: "30px" }}
          inlineCollapsed={true}
          theme="dark"
          defaultSelectedKeys={["1"]}
          mode="inline"
        >
          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/user-list")}
            icon={<img className="side-bar-icon" src={userIcon} />}
            key="1"
            className={currentKey === "1" ? "active-menu-item" : ""}
          >
            Users
          </Menu.Item>
          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/trainer")}
            icon={<img className="side-bar-icon" src={trainerIcon} />}
            key="40"
            className={currentKey === "40" ? "active-menu-item" : ""}
          >
            Trainer
          </Menu.Item>

          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/yogas")}
            icon={<img className="side-bar-icon" src={yogIcon} />}
            key="2"
            className={currentKey === "2" ? "active-menu-item" : ""}
          >
            FaceYogas
          </Menu.Item>

          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/videos")}
            icon={<img className="side-bar-icon" src={videoIcon} />}
            key="5"
            className={currentKey === "5" ? "active-menu-item" : ""}
          >
            Videos
          </Menu.Item>

          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/blogs")}
            icon={<img className="side-bar-icon" src={blogIcon} />}
            key="6"
            className={currentKey === "6" ? "active-menu-item" : ""}
          >
            Blogs
          </Menu.Item>
          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/categories")}
            icon={<img className="side-bar-icon" src={CategoryIcon} />}
            key="3"
            className={currentKey === "3" ? "active-menu-item" : ""}
          >
            Categories
          </Menu.Item>
          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/sub_categories")}
            icon={<img className="side-bar-icon" src={SUbCatIcon} />}
            key="18"
            className={currentKey === "18" ? "active-menu-item" : ""}
          >
            SubCategories
          </Menu.Item>
          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/feedbacks")}
            icon={<img className="side-bar-icon" src={feedbackIcon} />}
            key="9"
            className={currentKey === "9" ? "active-menu-item" : ""}
          >
            Feedbacks
          </Menu.Item>
          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/termsOfUse")}
            icon={<img className="side-bar-icon" src={serviceIcon} />}
            key="12"
            className={currentKey === "12" ? "active-menu-item" : ""}
          >
            Terms Of Use
          </Menu.Item>

          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/privacy-policy")}
            icon={<img className="side-bar-icon" src={privacyIcon} />}
            key="10"
            className={currentKey === "10" ? "active-menu-item" : ""}
          >
            Privacy Policy
          </Menu.Item>

          <Menu.Item
            onClick={logOut}
            key="11"
            icon={<LogoutOutlined className="side-bar-icon" />}
          >
            Log Out
          </Menu.Item>
        </Menu>
      </Sider>
      <Layout className="site-layout">
        <Header2 />
        <Content style={{ background: "#fff" }}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/termsOfUse" element={<TermsOfUse />} />
            <Route path="/videos" element={<Videos />} />{" "}
            <Route path="/blogs" element={<Blog />} />
            <Route path="/yogas" element={<FaceYoga />} />
            <Route path="/user-list" element={<UserLists />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/landing-page" element={<LandingPage />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/userSupports" element={<UserSupport />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/sub_categories" element={<SubCategories />} />
            <Route path="/feedbacks" element={<Feedbacks />} />
            <Route path="/trainer" element={<Trainer />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default LayoutDashboard;
